module.exports = __webpack_public_path__ + "static/media/tripleg.4be4f742.svg";